module.exports = __webpack_public_path__ + "static/img/icon3.4ee7e51f.png";